module.exports = __webpack_public_path__ + "static/media/rg.1c46515d.svg";